export default __webpack_public_path__ + "static/media/Home - Unlabeled Elite Ent.0b6d9cbd.png";